// extracted by mini-css-extract-plugin
export var actions = "geo-region-banner-module--actions--6b3df";
export var banner = "geo-region-banner-module--banner--78f87";
export var bannerDismissing = "geo-region-banner-module--bannerDismissing--25b6d";
export var closeButton = "geo-region-banner-module--closeButton--86955";
export var slideDown = "geo-region-banner-module--slideDown--e22c0";
export var slideUp = "geo-region-banner-module--slideUp--3783b";
export var text = "geo-region-banner-module--text--d02ef";